module.exports = __webpack_public_path__ + "static/media/sprite_exp_card_t4.44994e81.png";